import {jsx} from 'panel';

import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {isCohortSegment, SegmentValue} from 'common/query-builder/query-block/segment-menu/types';
import {Segmentation} from 'common/types/reports/query';
import {getLabelForPropertyType} from 'common/report/util/properties';
import {getPropertyType, setPropertyType} from 'common/query-builder/query-entry-section/row-types/row-util';
import {PropertyType} from 'common/report/constants';
import {ButtonSize} from 'common/components/button/constants';

import {ControlBarAction, ControlBarActionItems} from '../constants';

/**
 * Renders typecasting controls for a given Segmentation entry on filters or breakdowns
 */
export function TypecastSubitem({
  value,
  onTypeChange,
  forFilter,
  disabledTypes,
}: {
  value: SegmentValue;
  onTypeChange: (newValue: SegmentValue) => void;
  forFilter?: boolean;
  disabledTypes?: PropertyType[];
}) {
  if (!value || isCohortSegment(value)) {
    return null;
  }

  const segmentation = value as Segmentation;
  const fullType = getPropertyType(segmentation);

  return (
    <>
      {fullType.type && fullType.type !== segmentation.propertyDefaultType && (
        <div sel='.subitem-text'>
          <SelectEl
            sel='.subitem-select'
            attrs={{
              theme: SelectTheme.QbSubitem,
              size: ButtonSize.Small,
              'menu-width': null,
              'never-show-caret': true,
              label: `Data type changed to **${fullType.isList ? `List of ` : ``}${getLabelForPropertyType(
                fullType.type,
              )}**`,
              elref: `typecastSubitem`,
            }}
            props={{sections: ControlBarActionItems[ControlBarAction.Typecast](fullType, {disabledTypes}).subSections}}
            on={{
              change: (ev: CustomEvent) => {
                onTypeChange(setPropertyType(segmentation, ev.detail.item.value.toType, forFilter));
              },
            }}
          />
        </div>
      )}
    </>
  );
}
